(function(){
  var root = document.getElementById('mrf-home'); if (!root) return;
  var V = Number(root.dataset.v), PP = Number(root.dataset.pp), PLAN = root.dataset.plan ? Number(root.dataset.plan) : null, ROLLER = Number(root.dataset.roller);
  var PDP = '/products/mr-fuller-beard-serum';
  var sel = '2', subscribe = !!PLAN;
  var go = document.getElementById('mrf-go'), err = document.getElementById('mrf-err');
  var was = document.getElementById('mrf-was'), now = document.getElementById('mrf-now');
  var once = document.getElementById('mrf-once'), terms = document.getElementById('mrf-terms');
  var dealP = null;
  // Read the live Kaching deal from the product page, so the homepage always builds the same cart as the product page
  function getDeal(){
    if (!dealP) dealP = fetch(PDP, {credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var j = JSON.parse(doc.querySelector('script.kaching-bundles-deal-block-settings').textContent);
      var gifts = (j.progressiveGiftsEnabled && j.progressiveGifts && j.progressiveGifts.gifts || []).filter(function(g){ return g.giftType === 'product'; });
      return {deal: j.nanoId, v: j.versionId, gifts: gifts, bars: j.dealBars.map(function(b){ return {id: b.id, buy: b.buyQuantity, get: b.getQuantity || 0}; })};
    });
    return dealP;
  }
  function rid(){ var c='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', s=''; for (var i=0;i<4;i++) s += c[Math.floor(Math.random()*c.length)]; return s; }
  function tierEl(){ return root.querySelector('.mrf-tier[data-tier="'+sel+'"]'); }
  function render(){
    var t = tierEl(); if (!t) return;
    if (subscribe) { if (was) { was.style.display=''; was.textContent = t.dataset.once; } if (now) now.textContent = t.dataset.sub;
      if (once) once.innerHTML = 'Buy once — '+t.dataset.once+' (No savings)'; if (terms) terms.style.display=''; }
    else { if (was) was.style.display='none'; if (now) now.textContent = t.dataset.once;
      if (once) once.textContent = 'Switch to auto-refill and pay '+t.dataset.sub; if (terms) terms.style.display='none'; }
    root.querySelectorAll('.mrf-tier .now').forEach(function(n){ var tt=n.closest('.mrf-tier'); n.textContent = subscribe ? tt.dataset.sub : tt.dataset.once; });
  }
  root.querySelectorAll('.mrf-tier').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('.mrf-tier').forEach(function(x){ x.classList.remove('on'); x.setAttribute('aria-checked','false'); });
      b.classList.add('on'); b.setAttribute('aria-checked','true'); sel = b.getAttribute('data-tier'); render();
    });
  });
  if (once) once.addEventListener('click', function(e){ e.preventDefault(); subscribe = !subscribe; render(); });
  function buildItems(d){
    var n = Number(sel), bar = d.bars[n - 1], id = rid(), items = [];
    var main = {id: V, quantity: bar.buy, properties: {'__kaching_bundles': JSON.stringify({deal: d.deal, pp: PP, main: true, v: d.v, id: id, bar: bar.id})}};
    if (subscribe && PLAN) main.selling_plan = PLAN;
    items.push(main);
    if (bar.get > 0) {
      var free = {id: V, quantity: bar.get, properties: {'__kaching_bundles': JSON.stringify({id: id, deal: d.deal, bar: bar.id, v: d.v, main: true, bxgy: true})}};
      if (subscribe && PLAN) free.selling_plan = PLAN;
      items.push(free);
    }
    d.gifts.forEach(function(g){
      if (n >= (g.unlockAtBar || 99)) items.push({id: ROLLER, quantity: g.quantity || 1, properties: {'__kaching_bundles': JSON.stringify({id: id, deal: d.deal, v: d.v, gift: g.id})}});
    });
    return items;
  }
  window.mrfBuildItems = function(tier, sub){ var s0 = sel, b0 = subscribe; sel = String(tier); subscribe = sub; return getDeal().then(function(d){ var it = buildItems(d); sel = s0; subscribe = b0; return it; }); };
  go.addEventListener('click', function(){
    go.disabled = true; err.style.display = 'none';
    getDeal().then(function(d){
      var items = buildItems(d);
      return fetch('/cart/clear.js', {method:'POST'}).then(function(){
        return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})});
      });
    }).then(function(r){ if(!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function(){ go.disabled = false; err.style.display = 'block'; });
  });
  var sticky = document.getElementById('mrf-sticky'), buy = document.getElementById('mrf-buy');
  addEventListener('scroll', function(){ var r = buy.getBoundingClientRect(); sticky.classList.toggle('show', scrollY > 600 && !(r.top < innerHeight && r.bottom > 0)); }, {passive:true});
  render();
})();